import { getUserKey } from "./utils";
import moment from "moment";

export const getKey = (
  state,
  key,
  { userScope = true, sessionScope = false } = {}
) => {
  const data = state.storage[getUserKey(state, key, userScope, sessionScope)];
  // TODO ideally this deletes at some point - maybe with reducer setup?
  return data && (!data.expires || moment().isBefore(data.expires))
    ? data.value
    : undefined;
};
